export const SKELETON_APPLY_NOW_ANNOTATION = 'skeleton-apply-now-annotation-container';
export const SKELETON_CREDIT_SCORE_CONTAINER = 'skeleton-credit-score-container';
export const SKELETON_CREDIT_SCORE_LINE = 'skeleton-recommended-credit-score-line-container';
export const SKELETON_CREDIT_SCORE_TEXT = 'skeleton-recommended-credit-score-text-container';
export const SKELETON_FREE_CREDIT_SCORE = 'skeleton-get-your-free-credit-score-container';
export const SKELETON_RATES_AND_FEES = 'skeleton-rates-and-fees-container';
